





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateFormatter } from '@/util/DateFormatter';
import { DeliveryMethodDto } from '@/api';

@Component({})
export default class DeliverySection extends Vue {
  @Prop({required: true, type: Date})
  private startTime!: Date;

  @Prop({required: true, type: Date})
  private endTime!: Date;

  @Prop({required: true})
  private deliveryMethod!: DeliveryMethodDto;

  @Prop({required: false})
  private deliveryImage?: string;

  get deliveryDay() {
    return DateFormatter.formatDate(this.startTime);
  }

  get deliveryTime() {
    return DateFormatter.formatTime(this.startTime) + ' - ' + DateFormatter.formatTime(this.endTime);
  }

  get delivery() {
    return this.deliveryMethod === DeliveryMethodDto.DELIVERY;
  }

}
